<template>
  <el-dialog
    :title="title"
    :visible.sync="isVisible"
    width="900px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      :model="packageForm"
      ref="formRef"
      :rules="rules"
      :disabled="isDisabled"
      label-width="120px"
      :inline="false"
    >
      <el-form-item label="套餐名称" prop="menuName">
        <el-input
          maxlength="50"
          show-word-limit
          v-model="packageForm.menuName"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="套餐类型" prop="type">
        <el-radio-group v-model="packageForm.mealType">
          <el-radio :label="1">图片</el-radio>
          <el-radio :label="2">音频</el-radio>
          <el-radio :label="3">视频</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="定制套餐" prop="product" style="margin-bottom: 10px">
        <el-tooltip content="新增" placement="top" effect="dark">
          <i
            v-if="!isDisabled"
            class="el-icon-circle-plus-outline add-icon"
            @click="handleAddProduct"
          ></i>
        </el-tooltip>
      </el-form-item>
      <div class="productTable">
        <el-table :data="packageForm.product" border max-height="320">
          <el-table-column label="授权类型" prop="menuType">
            <template slot-scope="scope">
              <el-form-item
                class="marginUnset"
                :prop="`product.${scope.$index}.menuType`"
                :rules="rules.menuType"
              >
                <el-select v-model="scope.row.menuType" placeholder="请选择">
                  <el-option label="线上授权" value="线上授权"></el-option>
                  <el-option label="标准授权" value="标准授权"></el-option>
                  <el-option label="扩展授权" value="扩展授权"></el-option>
                  <el-option label="商品授权" value="商品授权"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="数量（张）" prop="count">
            <template slot-scope="scope">
              <el-form-item
                class="marginUnset"
                :prop="`product.${scope.$index}.count`"
                :rules="rules.count"
              >
                <el-input-number
                  v-model="scope.row.count"
                  :min="1"
                  :controls="false"
                  :max="99999"
                  :precision="0"
                  placeholder="请输入"
                  @keypress.native="onlyNumber"
                ></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="单价（元）" prop="price">
            <template slot-scope="scope">
              <el-form-item
                class="marginUnset"
                :prop="`product.${scope.$index}.price`"
                :rules="rules.price"
              >
                <el-input-number
                  v-model="scope.row.price"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  :max="99999"
                  placeholder="请输入"
                  @keypress.native="onlyNumberAndDecimal"
                ></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="总价（元）" prop="totalPrice">
            <template slot-scope="scope">
              <div>
                {{ calculateTotalPrice(scope.row.count, scope.row.price) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="operation">
            <template slot-scope="scope">
              <div v-if="packageForm.product.length > 1 && !isDisabled">
                <el-tooltip content="删除" placement="top" effect="dark">
                  <i
                    class="el-icon-remove-outline del-icon"
                    @click="handleRemoveProduct(scope.row.temp)"
                  >
                  </i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="download-time">
        <el-form-item label="下载完成时间" prop="expirationDate">
          <div class="input-wrapper">
            <el-input-number
              v-model="packageForm.expirationDate"
              :min="1"
              :max="365"
              :precision="0"
              placeholder="请输入天数"
              style="width: 200px"
              @change="calculateOverTime"
            ></el-input-number>
            <span class="unit">天内下载完成时间</span>
          </div>
        </el-form-item>
      </div>

      <div class="total-amount">
        <span class="label">
          <span style="color: red">*</span> 总计（元）：
        </span>
        <span class="amount">{{ formatTotal }}</span>
      </div>
      <el-form-item label="适用账号" prop="account">
        <el-radio-group v-model="packageForm.account">
          <el-radio label="0"> 全部 </el-radio>
          <el-radio label="1"> 指定账号 </el-radio>
        </el-radio-group>
        <designatedAccount
          :isDisabled="isDisabled"
          :mangerPhonesAarry="mangerPhonesAarry"
          v-model="packageForm.person"
          v-if="packageForm.account == 1"
        ></designatedAccount>
      </el-form-item>
      <el-form-item class="cust-item">
        <el-button @click="handleClose">取消</el-button>
        <el-button
          type="primary"
          :disabled="isDisabled"
          @click="handleSubmit('formRef')"
          >确定</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { addMade, grantEdit } from "@/api/package";
import designatedAccount from "./designatedAccount.vue";
import { formatNumberInt } from "@/utils/number";
import dayjs from "dayjs";

export default {
  name: "ManagementSideCreate",
  components: {
    designatedAccount,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dialogMode: {
      type: String,
      default: "add",
    },
    currentData: {
      type: Object,
      default: () => {},
    },
    mangerPhones: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    title() {
      return this.dialogMode === "add"
        ? "新建定制套餐"
        : this.dialogMode === "edit"
        ? "编辑定制套餐"
        : "详情";
    },
    isDisabled() {
      return this.dialogMode === "detail";
    },
    totalAmount() {
      return this.packageForm.product.reduce((total, item) => {
        const quantity = Number(item.count) || 0;
        const price = Number(item.price) || 0;
        return total + quantity * price;
      }, 0);
    },
    formatTotal() {
      return formatNumberInt(this.totalAmount, 2);
    },
  },
  watch: {
    mangerPhones: {
      handler(val) {
        this.mangerPhonesAarry = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      mangerPhonesAarry: [],
      packageForm: {
        mealType: 1,
        product: [
          {
            temp: this.mathRandom(),
            menuType: undefined,
            count: undefined,
            price: undefined,
            totalPrice: "",
          },
        ],
        expirationDate: 365,
        overTime: null,
        account: "0",
        menuName: "",
        person: [],
      },
      columns: [
        {
          id: 1,
          label: "数量（张）",
          prop: "count",
        },
        {
          id: 2,
          label: "单价（元）",
          prop: "price",
        },
        {
          id: 3,
          label: "总价（元）",
          prop: "totalPrice",
        },
        {
          id: 4,
          label: "操作",
          prop: "operation",
        },
      ],
      rules: {
        product: [
          { required: true, message: "套餐产品不能为空", trigger: "blur" },
        ],
        menuType: [
          { required: true, message: "套餐类型不能为空", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              const types = this.packageForm.product.map(
                (item) => item.menuType
              );
              const duplicates = types.filter((type) => type === value);
              if (duplicates.length > 1) {
                callback(new Error("同一套餐类型不能复"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        count: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!/^\d+$/.test(value)) {
                callback(new Error("请输入正整数"));
              } else if (value < 1 || value > 99999) {
                callback(new Error("数量范围为1-99999"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        price: [
          { required: true, message: "单价不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value < 0 || value > 99999) {
                callback(new Error("单价范围为0-99999"));
              } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                callback(new Error("最多支持两位小数"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        expirationDate: [
          { required: true, message: "下载完成时间不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value < 1 || value > 365) {
                callback(new Error("下载完成时间范围为1-365天"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        account: [
          { required: true, message: "适用账号不能为空", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (value == 1 && this.packageForm.person.length === 0) {
                callback(new Error("请选择适用账号"));
              } else {
                callback();
              }
            },
            trigger: ["change"],
          },
        ],
      },
    };
  },
  mounted() {
    this.handleInit();
    if (this.dialogMode === "add") {
      this.calculateOverTime();
    }
  },

  methods: {
    handleInit() {
      if (this.dialogMode == "edit" || this.dialogMode == "detail") {
        this.handleEditOrDetail();
      }
    },
    handleClose() {
      this.isVisible = false;
    },
    mathRandom() {
      return String(Math.random()).split(".")[1].slice(0, 16);
    },
    handleAddProduct() {
      this.packageForm.product.push({
        temp: this.mathRandom(),
        menuType: undefined,
        count: undefined,
        price: undefined,
        totalPrice: "",
      });
    },
    handleRemoveProduct(id) {
      this.packageForm.product = this.packageForm.product.filter(
        (item) => item.temp !== id
      );
    },
    handleEditOrDetail() {
      const { menuGrantChild } = this.currentData;

      this.packageForm.product = menuGrantChild.map((item) => ({
        id: item.id,
        menuType: item.menuType,
        count: item.count,
        price: item.price,
        totalPrice: item.allPrice,
        menuId: item.menuId,
        temp: item.id,
        expirationDate: item.expirationDate,
        overTime: item.overTime,
      }));

      if (menuGrantChild && menuGrantChild.length > 0) {
        const firstGrant = menuGrantChild[0];
        if (firstGrant.expirationDate) {
          const [startDate, endDate] = firstGrant.expirationDate.split(" - ");

          const start = dayjs(startDate);
          const end = dayjs(endDate);
          const diffDays = end.diff(start, "day");

          this.$nextTick(() => {
            this.packageForm.expirationDate = diffDays;
            this.calculateOverTime();
          });
        }
      }
      // 回显适用账号
      if (this.currentData.userId) {
        this.packageForm.account = "1";
        this.packageForm.person = this.currentData.userId.split(",");
      } else {
        this.packageForm.account = "0";
        this.packageForm.person = [];
      }
      // 回显套餐名称
      this.packageForm.menuName = this.currentData.menuName || "";
      this.packageForm.mealType = this.currentData.mealType || 1;
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 检查套餐类型是否重复
          const types = this.packageForm.product.map((item) => item.menuType);
          const uniqueTypes = new Set(types);
          if (types.length !== uniqueTypes.size) {
            this.$message.error("同一定制套餐中不能包含重复的套餐类型");
            return;
          }

          const startDate = dayjs().format("YYYY-MM-DD");
          const endDate = dayjs()
            .add(this.packageForm.expirationDate, "day")
            .format("YYYY-MM-DD");
          const menuGrantChildVos = this.packageForm.product.map((item) => ({
            menuType: item.menuType,
            count: item.count,
            price: item.price,
            allPrice: this.calculateTotalPrice(item.count, item.price),
            expirationDate: this.formatDateRange(startDate, endDate),
            overTime: this.packageForm.overTime,
          }));
          const params = {
            mealType: this.packageForm.mealType,
            menuGrantChildVos,
            totalPrice: formatNumberInt(this.totalAmount),
            id: this.currentData?.id,
            menuName: this.packageForm.menuName,
            userId:
              this.packageForm.account == 1
                ? this.packageForm.person.join()
                : "",
          };

          const paramsEdit = {
            ...params,
            grantId: this.currentData?.id,
          };
          const api = this.dialogMode === "add" ? addMade : grantEdit;
          const message = this.dialogMode === "add" ? "新增成功" : "编辑成功";
          const reqMethod = this.dialogMode === "add" ? "post" : "put";

          this.$ajax[reqMethod](
            api,
            this.dialogMode === "add" ? params : paramsEdit
          ).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(message);
              this.handleClose();
              this.$emit("refresh");
            }
          });
        }
      });
    },
    calculateTotalPrice(count, price) {
      if (!count || !price) return "";
      return count * price;
    },
    calculateOverTime() {
      if (this.packageForm.expirationDate) {
        const endDate = dayjs()
          .add(this.packageForm.expirationDate, "day")
          .format("YYYY-MM-DD");
        this.packageForm.overTime = dayjs(endDate)
          .add(1, "day")
          .format("YYYY-MM-DD");
      } else {
        this.packageForm.overTime = null;
      }
    },
    formatDate(date) {
      if (!date) return "";
      return dayjs(date).format("YYYY-MM-DD");
    },
    onlyNumber(e) {
      // 只允许输入数字
      if (!/^\d*$/.test(e.key)) {
        e.preventDefault();
      }
    },
    onlyNumberAndDecimal(e) {
      // 只允许输入数字和小数点
      if (!/^\d*\.?\d*$/.test(e.key)) {
        e.preventDefault();
      }
    },
    formatDateRange(startDate, endDate) {
      return `${startDate} - ${endDate}`;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__row .el-form-item__content {
  margin-left: unset !important;
}
::v-deep .el-input-number {
  width: 100% !important;
}
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
.add-icon,
.del-icon {
  color: black !important;
  cursor: pointer;
  font-size: 20px;
  margin-top: 10px;
}
.productTable {
  margin-left: 120px;
}
.marginUnset {
  margin-bottom: unset !important;
}
::v-deep .el-table__row .is-error {
  margin-bottom: 22px !important;
}
::v-deep .el-select {
  width: 100% !important;
}
.total-amount {
  margin-top: 20px;
  text-align: left;
  margin-left: 2rem;
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .amount {
    font-size: 16px;
    color: #000000;
  }
}
.download-time {
  margin-left: 0;
  margin-top: 20px;

  .input-wrapper {
    display: flex;
    align-items: center;
  }

  .unit {
    margin-left: 10px;
    color: #606266;
    white-space: nowrap;
  }
}
.cust-item {
  text-align: right;
}
</style>
